import { render } from "./CruResource.vue?vue&type=template&id=6f2f191c&scoped=true"
import script from "./CruResource.vue?vue&type=script&lang=js"
export * from "./CruResource.vue?vue&type=script&lang=js"

import "./CruResource.vue?vue&type=style&index=0&id=6f2f191c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f2f191c"]])

export default __exports__